import { ProjectTimeRow } from "./types";

export const getDailyFilename = (projectTimeEntry: ProjectTimeRow): string => {
  const employee = projectTimeEntry.employee!;
  const projectNumber = projectTimeEntry.project.number;
  const date = projectTimeEntry.date;
  return `${employee.firstName.toUpperCase()} ${employee.lastName.toUpperCase()} DAILY_${projectNumber}_${date}`;
};
